<template>
    <Data :data="data" v-if="!editing && !insert" :statusData="statusData"></Data>
</template>
<script>
import Data from "./Components/Data.vue";

export default {
    components: {
        Data 
    },
    data() {
        return {
            send: false,
            data: {
                quotaId: "QT-2025-001",
                quotaDateStr: "16.08.2025",
                quotaFullNumber: "Q-2025-007",
                generalDate: "01.08.2025",
                generalFullNumber: "GM-45678/2025",
                period: 36,
                currency: "AZN",
                payType: "Aylıq",
                // məsul şəxslər
                agentName: "Vafa Abilova",
                underwritingName: "Elvin Rzayev",
                curatorName: "Samir Qasımov",

                // sığortalı (компания)
                insured: {
                    name: "Xəzər Holdinq MMC",
                    address: "Bakı, Nərimanov r., Heydər Əliyev pr. 125",
                    phone: "+994 12 555 66 77",
                    clientSector: "Neft sektoru",
                    voen: "878455554865"
                },

                // faydalanan (физлицо)
                beneficiary: {
                    name: "Leyla Quliyeva",
                    address: "Bakı, Yasamal r., Şərifzadə küç. 45"
                }
            },
            statusData: [
                {
                    statusId: 0,
                    status: "Yeni",
                    user: "Rufiz Məmmədov",
                    time: "16.08.2025 14:22"
                },
                {
                    statusId: 4,
                    status: "Göndərildi təsdiqə",
                    user: "Aygün Quliyeva",
                    time: "16.08.2025 14:45"
                },
                {
                    statusId: 2,
                    status: "Təsdiqləndi",
                    user: "Admin",
                    time: "16.08.2025 15:05"
                }
            ],
            loading: false,
            editing: false,
            insert: false
        }
    },
    methods: {
        ToggleEdit() {
            this.$emit('insert')
        },
        async Delete() {
            //None
        }
    },
    mounted() {
        if (this.$route.path.split("/")[3] == null) {
            this.insert = true
        }
    }
}
</script>